import Dexie from 'dexie';

export class JobAccessDb extends Dexie {
  jobs: Dexie.Table<JobAccessData, string>;

  constructor() {
    super('JobAccess');
    this.version(1).stores({
      jobs: 'jobId'
    });
  }
}

export interface JobAccessData {
  jobId: number;
  currentStatusId: number;
  lastAccessedDate: number;
  accessedCount: number;
}